import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
export function Countdown() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(prev => prev <= 0 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const units = [{
    value: h,
    label: 'Hours'
  }, {
    value: m,
    label: 'Minutes'
  }, {
    value: s,
    label: 'Seconds'
  }];
  return <div className="mt-6 rounded-2xl bg-navy px-4 py-5 text-center text-white" role="timer" aria-live="off" data-id="element-20" data-mp="325j6il7518y1">
      <p className="flex items-center justify-center gap-2 text-sm font-bold text-gold" data-id="element-21" data-mp="374vuxadnqo2q">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-22" data-mp="10d4v84z3n2ql" />
        The promotional price ends in:
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-23" data-mp="159bxnnsadw3s">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-24" data-mp="xz3oa76eved0" data-mpi={i}>
            <div className="flex w-[74px] flex-col items-center" data-id="element-25" data-mp="t2vcn3rfa3al">
              <span className="w-full rounded-xl bg-white py-2 text-[32px] font-extrabold tabular-nums leading-none text-navy" data-id="element-26" data-mp="17qzwwc64imvh">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wide text-white/70" data-id="element-27" data-mp="f2arw21y5xeg">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-2 text-2xl font-extrabold text-gold" data-id="element-28" data-mp="a4sg83wjp42r">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}